import { RetiredTopInfoBoxUI } from "./RetiredTopInfoBoxUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ensureIsRetired } from "../../utils/product/ensureIsRetired";

export const RetiredTopInfoBox = ({
  product,
}: Pick<StandardProps, "product">) => {
  const { variant } = useVariant(product);

  const retiredProduct = ensureIsRetired(product);
  if (!retiredProduct) return null;

  return (
    <RetiredTopInfoBoxUI
      title={product.title}
      primaryImageUrl={variant.images.primary}
      productType={product.__typename}
    />
  );
};
